<template>
  <animated-mask class="intro">
    <mdb-container class="intro-content animated fadeIn">
      <mdb-row>
        <mdb-col col="auto" class="logo-center text-center">
          <company-logo 
            :companyName="companyName" 
            :companyBranch="companyBranch" 
            :companySkillset="companySkillset"
            class="z-depth-2" />
        </mdb-col>
      </mdb-row>
      <mdb-row>
        <mdb-col md="12" class="text-center animated fadeIn">
          <hr class="my-4 pb-2">
          <a :href="this.computedPhoneLink">
            <mdb-btn class="btn-rounded z-depth-1 overlay" color="mdb-color" icon="phone">
              Call us
              <mdb-mask overlay="white-light" />
            </mdb-btn>
          </a>
          <a :href="this.computedEmailLink">
            <mdb-btn class="btn-rounded z-depth-1 overlay" color="mdb-color" icon="envelope">
              Email us
              <mdb-mask overlay="white-light" />
            </mdb-btn>
          </a>
        </mdb-col>
      </mdb-row>
      <mdb-row v-if="pointerLink">
        <mdb-col col="12" class="down-bouncer-container d-flex align-self-stretch flex-column">
          <a href="#" v-scroll-to="formatAnchorLink(pointerLink)">
            <div class="down-bouncer bounce">
              <mdb-icon icon="chevron-down" class="top-arrow" size="4x" /><br />
              <mdb-icon icon="angle-down" class="bottom-arrow" size="3x" />
            </div>
          </a>
        </mdb-col>
      </mdb-row>
    </mdb-container>
  </animated-mask>
</template>

<script>
import {
  mdbMask,
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbBtn,
  mdbIcon
} from 'mdbvue'
import AnimatedMask from '@/components/AnimatedMask.vue'
import CompanyLogo from '@/components/CompanyLogo.vue'

export default {
  name: 'CompanyIntro',
  props: {
    companyName: String,
    companyBranch: String,
    companySkillset: String,
    companyPhone: String,
    companyEmail: String,
    pointerLink: String
  },
  components: {
    mdbMask,
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbBtn,
    mdbIcon,
    AnimatedMask,
    CompanyLogo
  },
  data() {
    return {
      computedPhoneLink: "tel:"+this.companyPhone,
      computedEmailLink: "mailto:"+this.companyEmail
    }
  },
  methods: {
    formatAnchorLink: (section) => {
      return '#' + section;
    }
  }
}
</script>

<style scoped>
.intro {
  height: 100%;
  min-height: 730px;
  background: black;
}

.intro-content {
  position: relative;
  top: 50%;
  transform: translate(0%, -50%);
}

.logo-center {
  margin: 0;
  position: relative;
  left: 50%;
  transform: translate(-50%, 0%);
}

/* Fix for missing funcitonality, in wait of patches. */
.btn-rounded {
  border-radius: 10em;
}

/* Bouncing arrow */
.down-bouncer-container{
}
.down-bouncer{
  position: relative;
  top: 30px;
  color: white;
}
.top-arrow {
  color: #939393;
}
.bottom-arrow {
  position: relative;
  top: -25px;
  color: #939393;
}
.bounce {
  -moz-animation: bounce 3s infinite;
  -webkit-animation: bounce 3s infinite;
  animation: bounce 3s infinite;
}
@-moz-keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    -moz-transform: translateY(0);
    transform: translateY(0);
  }
  40% {
    -moz-transform: translateY(-30px);
    transform: translateY(-30px);
  }
  60% {
    -moz-transform: translateY(-15px);
    transform: translateY(-15px);
  }
}
@-webkit-keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  40% {
    -webkit-transform: translateY(-30px);
    transform: translateY(-30px);
  }
  60% {
    -webkit-transform: translateY(-15px);
    transform: translateY(-15px);
  }
}
@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    -moz-transform: translateY(0);
    -ms-transform: translateY(0);
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  40% {
    -moz-transform: translateY(-30px);
    -ms-transform: translateY(-30px);
    -webkit-transform: translateY(-30px);
    transform: translateY(-30px);
  }
  60% {
    -moz-transform: translateY(-15px);
    -ms-transform: translateY(-15px);
    -webkit-transform: translateY(-15px);
    transform: translateY(-15px);
  }
}
</style>